const injectNavattic = () => {
  const head = document.getElementsByTagName('head')[0]
  const urlPath = 'https://js.navattic.com/embeds.js'

  if (document.getElementById('navattic-script')) {
    return
  }

  const script = document.createElement('script')
  script.id = 'navattic-script'
  script.src = urlPath
  script.onload = () => {
    const event = new Event('navatticIsOn')
    window.dispatchEvent(event)

    const config = { title: 'Painel do hub' }

    // @ts-ignore
    window.NavatticEmbed = NavatticEmbed
    // @ts-ignore
    window.NavatticEmbed.initPopup('https://capture.navattic.com/cm6z1fbzy000503lb7pya64n4', config)
  }
  head.appendChild(script)
}

export default injectNavattic
